import { render, staticRenderFns } from "./lamsPresentList.vue?vue&type=template&id=5537d024&scoped=true&"
import script from "./lamsPresentList.vue?vue&type=script&lang=js&"
export * from "./lamsPresentList.vue?vue&type=script&lang=js&"
import style0 from "./lamsPresentList.vue?vue&type=style&index=0&id=5537d024&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5537d024",
  null
  
)

export default component.exports